const SubAbasProgEstrategico = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/secsaude/programacao/estrategico/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasProgEstrategico;
